module.exports = __webpack_public_path__ + "static/media/pngCaxiasLogo.61632527.png";